import React, { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import locales from '../../../content.json';
import { BrandButton } from '../../everydoggyV2/brandButton/brandButton';
import s from './getMyPlanBlock.module.scss';
import { showPaymentModal } from '../../../reduxStore/navigation/actions';
import { RootState } from '../../../store';
import { PAYMENT_TARIFF } from '../../../types';
import { getCurrencySymbolFromISOCode } from '../../../utils/scripts/currency';

interface GetMyPlanBlockProps {
  tariff?: string;
  special?: boolean;
  secondScreen?: boolean;
}

export const GetMyPlanBlock = ({ tariff }: GetMyPlanBlockProps) => {
  const dispatch = useDispatch();

  const paymentModal = useSelector((state: RootState) => state.data.paymentModal);
  const animateButton = useSelector((state: RootState) => state.data.animateButton);

  const product = paymentModal.productName?.name;
  const price = paymentModal?.product?.details?.trial_amount || paymentModal?.product?.details?.amount;
  const saleValue = tariff === PAYMENT_TARIFF.V21 ? '53%' : '65%';

  const currency = getCurrencySymbolFromISOCode();

  const doOnClick = useCallback(() => {
    dispatch(showPaymentModal({ product, currency, price: Number(price) }));
  }, [dispatch, product, currency, price]);

  return (
    <div className={`${s.getMyPlanBlock} ${tariff === PAYMENT_TARIFF.V22 || tariff === PAYMENT_TARIFF.V28 ? s.tariffV5 : ''}`}>
      <BrandButton data-test="open-payment-modal" onClick={doOnClick} animateButton={animateButton}>
        <p>{locales[window.userLang].get_my_plan}</p>
      </BrandButton>
    </div>
  );
};
